import { Progress } from "alm-react-components";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { APPROUTES, ErrorType, FileNotation, Tag } from "../../../../assets/constants/constants";
import { CourseDetailParmsType } from "../../../../interface";
import getLocalizedContent from "../../../../lib/getLocalizedMetaData";
import { badgeUrl, courseProgress, filterEnrollmentData } from "../../../../lib/utils";
import { ShareAndBookMark } from "../../../common/ShareAndBookMark";
import { CourseComplete } from "./CourseComplete";
import { CoursePlayerSection } from "./CoursePlayerSection";
import { WeekDetail } from "./WeekDetail";
import { DetailTabSection } from "../tab-section/DetailTabSection";

type CourseDetailContainerProps = {
  programData: any;
  courseResponse: any;
};
export const CourseDetailContainer: React.FC<CourseDetailContainerProps> = ({
  programData,
  courseResponse,
}) => {
  const { t } = useTranslation();
  const { mainLearningProgramId, learningProgramId, courseId } =
    useParams() as CourseDetailParmsType;
    const [query] = useSearchParams();
    const sequenceId: any = query.get("sequence");
    const weekId=sequenceId?.split("")[0]
  const [weekData, setWeekData] = useState<any>(null);
  const [courseList, setCourseList] = useState<any>(null);
  const [hours, setHours] = useState<number>(0);
  const [minutes, setMinutes] = useState<number>(0);
  const [completedCourses, setCompletedCourses] = useState<any>([]);
  const [totalCourseCount, setTotalCourseCount] = useState<number>(0);
  const navigate = useNavigate();
  const [playCourse, setPlayCourse] = useState(false);
  const [currentLesson, setCurrentLesson] = useState<number>(0);
  const [lessonTranscriptLocation, setLessonTranscriptLocation] =
    useState<string>("");

  const [
    courseRelationshipsInstancesLoResourcesId,
    setCourseRelationshipsInstancesLoResourcesId,
  ] = useState<string>("");
  const [
    liveMeetingDetail,
    setLiveMeetingDetail,
  ] = useState<string>("");

  const [exerciseModule,setExerciseModule]=useState<any>();

  useEffect(() => {
    if (programData) {
      const enrollmentId = programData.data.relationships?.enrollment?.data?.id;
      const enrollmentData = filterEnrollmentData(programData, enrollmentId);
      
      const weekResponse = programData?.included?.find(
        (ele: any) => ele?.id === learningProgramId
      );
      if(weekResponse === undefined) {
        navigate(`${APPROUTES.error}/${ErrorType.courseNotFound}`);
        return;
      }
      const mainProgramContent = getLocalizedContent(
          programData?.data?.attributes?.localizedMetadata
        );
      setWeekData(weekResponse);

      const courseList: any = [];
      // format time
      const seconds = weekResponse?.attributes?.duration;
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      setHours(hours);
      setMinutes(minutes);

      const sections=weekResponse?.attributes?.sections;
      const childrenSectionsLoIds:any=[]
      for(const sec of sections){
        for(const ids of sec.loIds){
          childrenSectionsLoIds.push({id:ids,mandatory:sec?.mandatory})
        }
      }
      childrenSectionsLoIds?.forEach((responseItem: any) => {
        const courses = programData?.included?.find(
          (ele: any) => ele?.id == responseItem?.id
        );

        if (courses.id === courseId) setCourseOtherData(courses);

        const content = getLocalizedContent(
          courses?.attributes?.localizedMetadata
        );

        const courserelationships = programData?.included?.find((ele: any) => {
          return ele.id === courses.relationships?.enrollment?.data?.id;
        });
courseList.push({
          state :courserelationships?.attributes?.state,
          id: courses?.id,
          name: content?.name,
          bannerUrl: courses?.attributes?.bannerUrl,
          coverUrl: courses?.attributes?.imageUrl,
          description: content?.description,
          isBookmarked: courses?.attributes?.isBookmarked,
          coursesTags: courses.attributes.tags,
          courseRelationshipsEnrollmentId:
            courses?.relationships?.enrollment?.data?.id,
          courseRelationshipsInstancesId:
            courses?.relationships?.instances?.data[0]?.id,
          isExercise: courses?.attributes?.tags?.includes(Tag.exercise),
          liveclass: courses?.attributes?.tags?.includes(Tag.liveclass),
          isliveclass: courses?.attributes?.tags?.includes(Tag.liveclass),
          isDocument: courses?.attributes?.tags?.includes(Tag.documents),
          tags: courses?.attributes?.tags,
          supplementaryResources:courses?.relationships?.supplementaryResources?.data,
          programName:mainProgramContent?.name,
          programProgressPercent:enrollmentData?.progressPercent,
          mandatory:responseItem?.mandatory
        });
      })
      setCourseList(courseList);
    }
  }, [programData]);

  useEffect(() => {
    if (programData) {
      const response2 = programData?.data?.relationships?.subLOs?.data;
      let totalCourseCount = 0;
      response2?.forEach((responseItem:any)=>{
        const LPDetails = programData?.included?.find(
          (ele: any) => ele.id == responseItem.id
        );
        const learningPathCourseDetails = programData?.included?.find(
          (ele: any) => ele?.id === LPDetails?.id
        );
         if (learningPathCourseDetails) {
          totalCourseCount +=
            learningPathCourseDetails?.relationships?.subLOs?.data?.length || 0;
        }
      })
       setTotalCourseCount(totalCourseCount); 

      const completedCourseList = courseProgress(programData, response2);
      setCompletedCourses(completedCourseList);
    }
  }, [programData]);

  // Set the live lesston
  const setCourseOtherData = (courses: any) => {

    supplementaryResources(courses);
    if (courses?.attributes?.tags?.includes(Tag.liveclass)) {
      const courseRelationshipsInstances = programData?.included?.find(
        (ele: any) => {
          return ele.id === courses?.relationships?.instances?.data[0]?.id;
        }
      );
      ///Get recording lession/module id 
      const courseRelationshipsInstancesLoResourcesId =
        programData?.included?.find((ele: any) => {
          return (
            ele.id ===
            courseRelationshipsInstances?.relationships?.loResources?.data[1]
              ?.id
          );
        });
      ///Set recording lession/module id 
      if (courseRelationshipsInstancesLoResourcesId) {
        setCourseRelationshipsInstancesLoResourcesId(
          courseRelationshipsInstancesLoResourcesId.id
        );
      }
      ///Extract live meting detail 
      ///Get live lession/module id 
      const courseRelationshipsInstancesLoResourcesIdLive =
        programData?.included?.find((ele: any) => {
          return (
            ele.id ===
            courseRelationshipsInstances?.relationships?.loResources?.data[0]
              ?.id
          );
        });
      ///Get live lession/module detail 
      const courseRelationshipsInstancesLoResourcesIdLiveMeetingModule=
        programData?.included?.find((ele: any) => {
          return (
            ele.id ===
            courseRelationshipsInstancesLoResourcesIdLive?.relationships?.resources?.data[0]
              ?.id
          );
        });
      if(courseRelationshipsInstancesLoResourcesIdLiveMeetingModule?.id){
        setLiveMeetingDetail(courseRelationshipsInstancesLoResourcesIdLiveMeetingModule)
      }
    }
    if (courses?.attributes?.tags?.includes(Tag.exercise)) {

      const courseRelationshipsInstances = programData?.included?.find(
        (ele: any) => {
          return ele.id === courses?.relationships?.enrollment?.data?.id;
        }
      );

      const exerciseModule:any=[];
      courseRelationshipsInstances.relationships.loResourceGrades.data.map((elem:any)=>{
         
        const courseRelationshipsInstancesLoResourcesIdl =  programData?.included?.find((ele: any) => {
          return (
            ele.id === elem.id
          );

        });
        //check if exercises id  are available in the course attributes tags
        if(courseResponse?.attributes?.tags.filter((item:string) => item.split(':')[0] === Tag.exercise.toLocaleLowerCase())?.length > 0){
          exerciseModule.push(elem.id)
        }else{
          if(!courseRelationshipsInstancesLoResourcesIdl.attributes.completed){
            exerciseModule.push(elem.id)
          }
        }

      })
      setExerciseModule(exerciseModule)
      
    }
  };

  const supplementaryResources = (courses: any) => {
    courses?.relationships?.supplementaryResources?.data.forEach((val: any) => {
      programData?.included?.find((ele: any) => {
        if (ele.id === val.id) {
          const file = ele.attributes.name;
          if (file.endsWith(FileNotation.transcript)) {
            setLessonTranscriptLocation(ele?.attributes?.location);
          }
        }
      });
    });
  };

  const courseUpdate = (id: any,sequence?:any) => {
    setPlayCourse(false);
    if(sequence){
      navigate(
        `/course-detail/${mainLearningProgramId}/${learningProgramId}/${id}?sequence=${sequence}`
      );
    }else{
      navigate(
        `/course-detail/${mainLearningProgramId}/${learningProgramId}/${id}`
      );
    }
  };

  useEffect(() => {
    if (courseId && courseList)
      courseList?.forEach((val: any, index: number) => {
        if (val.id == courseId) {
          setCurrentLesson(index + 1);
        }
      });
  }, [courseList]);

  const updateCompaletedStatus = () => { 
   const checkCourseExit= completedCourses.find((val:string)=>val===courseId)
   if(!checkCourseExit) setCompletedCourses([...completedCourses,courseId])
  };

  const onPressBookMark = (flag: boolean) => {
    const updatedCourseList = courseList.map((val: any) =>
      val.id == courseId ? { ...val, isBookmarked: flag } : val
    );

    setCourseList(updatedCourseList);
  };

  const content = getLocalizedContent(
    courseResponse?.attributes?.localizedMetadata
  );

  const getCurrentCourseDetail = () =>{
    return courseList?.filter((val: any) => val.id == courseId)[0];
  }
  return (
    <>
      <section className="h-fit">
        <div className="gap-6 xl:gap-6 lg:grid lg:grid-cols-3 md:flex md:flex-col py-5 mx-auto md:py-8 px-4 xl:px-32 md:px-8 lg:px-8">
          {programData && courseResponse?.id && (
            <div className="col-span-2 pb-4">
              <CoursePlayerSection
                programData={programData}
                courseId={courseId}
                playCourse={playCourse}
                courseResponse={courseResponse}
                courseRelationshipsInstancesLoResourcesId={
                  courseRelationshipsInstancesLoResourcesId
                }
                courseList={courseList}
                updateCompaletedStatus={updateCompaletedStatus}
                courseUpdate={courseUpdate}
                setPlayCourse={setPlayCourse}
                currentLesson={currentLesson}
                liveMeetingDetail={liveMeetingDetail}
                currentLessionDetail={getCurrentCourseDetail()}
                exerciseModule={exerciseModule}
                completedCourses={completedCourses}
              />
              <div className="gap-4 xl:gap-8 md:grid md:grid-cols-3 max-w-screen-xl max-sm:block max-md:flex max-md:justify-between">
                <div className="col-span-2 pb-4 flex flex-col">
                  <h4 className="font-light tracking-wider text-xl font-barlowLight">
                  <span dangerouslySetInnerHTML={{ __html: (t("Program.lesson")) }} /> {currentLesson}
                  </h4>
                  <h2 className="lg:text-xl xl:text-2xl 2xl:text-3xl  font-barlowLight text-left mt-3">
                    {content?.name}
                  </h2>
                  <p className="mt-3 text-base font-opensansLight tracking-wider">
                    {content?.description}
                  </p>
                </div>
                <div className="pb-4 flex flex-col items-end"> 
                {programData &&
                    courseList &&
                    courseResponse?.attributes?.tags?.includes(
                      Tag.exercise
                    ) &&  !(courseResponse?.attributes?.tags.filter((item:string) => item.split(':')[0] === Tag.exercise.toLocaleLowerCase())?.length > 0) && (
                       <CourseComplete
                        currentLessionDetail={getCurrentCourseDetail()}
                        updateCompletedCourse={updateCompaletedStatus}
                        programData={programData}
                        exerciseModule={exerciseModule}
                      />
                    )}
                  {courseList && courseId && !courseResponse?.attributes?.tags?.includes(
                      Tag.exercise
                    ) && (
                    <ShareAndBookMark
                      courseId={courseId}
                      isBookmarked={
                        courseList.filter((val: any) => val.id == courseId)[0]
                          .isBookmarked
                      }
                      setBookmarked={onPressBookMark}
                      courseName={
                        courseList.filter((val: any) => val.id == courseId)[0]
                          .name
                      }
                    />
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="mt-4 md:mt-0">
            <div className="gap-5 grid grid-cols-3 dark:bg-fillMidGrayCard font-medium rounded-lg text-sm px-5 py-4 dark:focus:ring-[#3b5998]/55 me-2 mb-2 w-full">
              <div className="col-span-2 pe-4 flex flex-col text-left">
                <h4 className="font-light text-base font-barlowLight uppercase pb-0 mb-0"
                dangerouslySetInnerHTML={{ __html: (t("CourseDetails.programTitle")) }} />
                <h2 className="lg:text-xl xl:text-2xl font-barlowSemiBold">
                  {content?.name}
                </h2>
                <p className="mt-2 text-base font-opensansLight text-start">
                  <span className="font-opensansBold font-opensansSemiBold">
                    {weekData?.relationships?.subLOs?.data?.length}{" "}
                     <span dangerouslySetInnerHTML={{ __html: (t("Common.lessons")) }} />
                  </span>{" "}
                  (
                  {hours}{" "}
                  <span dangerouslySetInnerHTML={{ __html: (t("Program.hr")) }} />{" "}
                  {minutes}{" "}
                  <span dangerouslySetInnerHTML={{ __html: (t("Program.mins")) }} />
                  )
                </p>
              </div>
              <div className="flex align-top justify-end">
                <img
                  src={badgeUrl(programData?.data?.relationships?.instances?.data[0]?.id, programData?.included)}
                  alt="icon-image"
                  className="max-w-[106px] w-fit h-min max-h-[106px] yellow"
                />
              </div>
            </div>

            {courseList && (
              <WeekDetail
                courseUpdate={courseUpdate}
                weekResponse={weekData}
                courseList={courseList}
                courseId={courseId}
                weekId={weekId}
                completedCourses={completedCourses}
              />
            )}

            <div className=" flex dark:bg-fillMidGrayCard font-medium rounded-lg text-sm px-5 py-4 dark:focus:ring-[#3b5998]/55 me-2 mb-2 w-full">
              <div className="program-badge-sm flex flex-none">
                <img
                  src={badgeUrl(programData?.data?.relationships?.instances?.data[0]?.id, programData?.included)}
                  className="rounded-md p-3 max-w-[61px] h-[auto] m-auto yellow"
                  alt={t("courseDetails.fallbackTextForProgram").replace(/<\/?[^>]+(>|$)/g, "")}
                />
              </div>
              <div className="col-span-2 ps-4 flex flex-col text-left">
                <p className="mt-2 text-sm font-opensansLight text-start"
                dangerouslySetInnerHTML={{ __html: (t("CourseDetails.progressText")) }}/>
                {programData && courseList !== null && (
                  <div className="flex items-center mt-4">
                    <div className=" text-base font-opensansSemiBold pr-4">{`${completedCourses.length} ${t('Common.of')} ${totalCourseCount}`}</div>
                    <div className="flex-1 min-w-0">
                      <Progress
                        value={
                          courseList[0]?.programProgressPercent
                        }
                        className="w-full h-[7px] bg-fillDarkGrayCard"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      {courseId && (
        <DetailTabSection
          courseResponse={courseResponse}
          mainLearningProgramId={mainLearningProgramId}
          learningProgramId={learningProgramId}
          courseId={courseId}
          selectedProgram={
            getLocalizedContent(
              programData?.data?.attributes?.localizedMetadata
            )?.name
          }
          type=""
          transcriptLocation={lessonTranscriptLocation}
          isUserEnrolled={true}
          weekName={getLocalizedContent(weekData?.attributes?.localizedMetadata).name}
          currentLessionDetail={getCurrentCourseDetail()}
        />
      )}
    </>
  );
};
